module.exports = __webpack_public_path__ + "static/img/bonus_7.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_7.png
// module id = 2Rp0
// module chunks = 0